import React from "react";
import { Toggle as MSToggle } from "@fluentui/react";
import { useField } from "formik";

const Toggle = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(props);

  function _onChange(ev, checked) {
    helpers.setValue(checked);
  }

  return (
      <MSToggle onChange={_onChange} checked={field.value} {...props} />
  );
};

export default Toggle;
